"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const react_2 = require("react");
const react_lazy_load_image_component_1 = require("react-lazy-load-image-component");
const RotationAwareImageComponent_1 = __importDefault(require("@mwater/forms/lib/RotationAwareImageComponent"));
const ImagePopupComponent_1 = __importDefault(require("./ImagePopupComponent"));
/** Creates an image mosaic chart */
function ImageMosaicChartViewComponent(props) {
    const { design, data, dataSource, width, height, onRowClick } = props;
    const imagePopupRef = (0, react_2.useRef)(null);
    const [isPrinting, setIsPrinting] = (0, react_2.useState)(false);
    (0, react_2.useEffect)(() => {
        const mediaQueryList = window.matchMedia('print');
        const handlePrintChange = (mql) => {
            setIsPrinting(mql.matches);
        };
        mediaQueryList.addEventListener('change', handlePrintChange);
        return () => {
            mediaQueryList.removeEventListener('change', handlePrintChange);
        };
    }, []);
    const handleClick = (0, react_2.useCallback)((primaryKey, image) => {
        if (onRowClick) {
            return onRowClick(design.table, primaryKey);
        }
        else {
            return imagePopupRef.current?.show(image);
        }
    }, [onRowClick, design.table]);
    // Render a single image
    const renderImage = (0, react_2.useCallback)((primaryKey, image, imageManager) => {
        const imageComponent = (react_1.default.createElement(RotationAwareImageComponent_1.default, { imageManager: imageManager, image: image, thumbnail: true, height: 120, width: 80, onClick: () => handleClick(primaryKey, image) }));
        // DISABLED PRINTING AS WAS CRASHING CHROME
        return isPrinting && false ? (react_1.default.createElement("div", { style: { display: "inline-block", minWidth: "50px" }, key: image.id }, imageComponent)) : (react_1.default.createElement(react_lazy_load_image_component_1.LazyLoadComponent, { key: image.id }, imageComponent));
    }, [handleClick, isPrinting]);
    // Render images
    const renderImages = (0, react_2.useCallback)((imageManager) => {
        const result = [];
        for (let row of data) {
            let imageObj = row.image;
            // Ignore nulls (https://github.com/mWater/mwater-server/issues/202)
            if (!imageObj) {
                continue;
            }
            if (lodash_1.default.isString(imageObj)) {
                imageObj = JSON.parse(imageObj);
            }
            if (lodash_1.default.isArray(imageObj)) {
                result.push(imageObj.map((image) => renderImage(row.id, image, imageManager)));
            }
            else {
                result.push(renderImage(row.id, imageObj, imageManager));
            }
        }
        return result;
    }, [data, renderImage]);
    const titleStyle = {
        textAlign: "center",
        fontSize: "14px",
        fontWeight: "bold"
    };
    const style = {
        width,
        height,
        position: "relative",
        overflowY: "auto"
    };
    const title = design.titleText;
    const imageManager = {
        getImageThumbnailUrl: (id, success, error) => success(dataSource.getImageUrl(id, 100)),
        getImageUrl: (id, success, error) => success(dataSource.getImageUrl(id))
    };
    return (react_1.default.createElement("div", { style: style, className: "image-mosaic" },
        title && react_1.default.createElement("p", { style: titleStyle }, title),
        react_1.default.createElement(ImagePopupComponent_1.default, { ref: imagePopupRef, imageManager: imageManager }),
        react_1.default.createElement("div", null, renderImages(imageManager))));
}
exports.default = ImageMosaicChartViewComponent;
